<div class="row" style="margin: 0px;">
  <div class="col-md-6" style="padding: 0;">
    <fieldset class="mat-mdc-card sgd-card" style="padding-top: 0;min-inline-size:unset">      
      <mat-toolbar style="padding: 0;">
        Anexos<span class="sgd-spacer"></span>               
        @if(hasParticipated && isOwner && showDeleteButton()){
        <button type="button" mat-icon-button matTooltip="Agregar archivo externo" (click)="openDlgAnexosFijo()">
          <mat-icon class="material-symbols-outlined">attach_file_add</mat-icon>
        </button>&nbsp;
        <button type="button" matTooltip="Redacta un documento" mat-stroked-button (click)="redactar()">
          <mat-icon class="material-symbols-outlined">
            stylus_note
          </mat-icon>
          Redactar
        </button>
        }
      </mat-toolbar>
      @if(isScope){
          <span class="card-alcance"> En alcance guarde su documento y en elaboración puede agregar anexos.</span>
        } 
      <mat-list style="margin: -16px;">
        @if (anexosDocs.length > 0) {
        @for (anexo of anexosDocs; track anexo.id) {
        <mat-list-item>
          <div matListItemIcon style="width: auto; display: flex; align-items: center; margin-top: 12px;">
            @if (hasParticipated) {
            <mat-checkbox 
              [checked]="isAnexoMencionado(anexo.id!)" 
              (change)="toggleAnexoMencionado(anexo.id!, $event.checked)"
              matTooltip="Mencionar"
              color="primary"
              style="margin-right: 4px; transform: scale(0.9);">
            </mat-checkbox>
            <button type="button" matTooltip="Descargar" mat-icon-button (click)="downloadAnexo(anexo.id!)">
              <mat-icon>download</mat-icon>
            </button>
            }
          </div>
          <div matListItemTitle>
            @if (hasParticipated) {
            <a href="javascript:void(0)" matTooltip="{{getNombreAdjunto(anexo)}}"
              (click)="openAnexo(anexo.id!)">{{getNombreAdjunto(anexo)}}</a>
            }@else {
            <span matTooltip="{{getNombreAdjunto(anexo)}}">{{getNombreAdjunto(anexo)}}</span>
            }
          </div>
          @if (anexo.nombre){
          <div matListItemLine>{{anexo.nombre}}</div>
          }

          <div matListItemLine>{{formatDate(anexo.fecha!)}}</div>
          <span matListItemMeta style="margin-top: 12px;margin-left: 8px">
            @if (hasParticipated) {
            <button type="button" mat-icon-button [matMenuTriggerFor]="menuAnexo">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menuAnexo="matMenu">
              @if(isOwner && checkAnexoPDF(anexo.id!)){
              <button mat-menu-item (click)="openDlgSignAnexo(anexo.id!)">
                <mat-icon>vpn_key</mat-icon><span>Firmar</span>
              </button>
              }
              @if(isOwner && anexo.idMemo && anexo.tarea == idTarea && showDeleteButton()){
              <button mat-menu-item (click)="onMultipleSign(anexo.id!)">
                <mat-icon> diversity_3 </mat-icon><span>Firma conjunta</span>
              </button>
              }
              @if (isOwner && anexo.idMemo && anexo.tarea == idTarea && showDeleteButton()) {
              <button type="button" mat-menu-item (click)="onEditAnexoMemo(anexo.id!)">
                <mat-icon>edit</mat-icon><span>Editar</span>
              </button>
              }
              @if (isOwner && anexo.tarea == idTarea && showDeleteButton()) {
              <button type="button" mat-menu-item (click)="onDeleteAnexo(anexo.id!)">
                <mat-icon>delete</mat-icon><span>Eliminar</span>
              </button>
              }
            </mat-menu>
            }
          </span>
        </mat-list-item>
        }
        }@else {
        <p style="margin-left:18px">Aqu&iacute; se mostrar&aacute;n los anexos agregados!</p>
        }
      </mat-list>
    </fieldset>
  </div>
  <div class="col-md-6" style="padding: 0;">
    @if(anexosOficios.length > 0){
    <fieldset class="mat-mdc-card sgd-card" style="padding-top: 0;min-inline-size:unset">
      <mat-toolbar style="padding: 0;">
        Oficios<span class="sgd-spacer"></span>
      </mat-toolbar>
      <mat-list style="margin: -16px;">
        @for (anexo of anexosOficios; track anexo.id) {
        <mat-list-item>
          <div matListItemIcon style="width: auto; display: flex; align-items: center; margin-top: 12px;">
            @if (hasParticipated) {
            <button type="button" matTooltip="Descargar" mat-icon-button (click)="downloadAnexo(anexo.id!)">
              <mat-icon>download</mat-icon>
            </button>
            @if (isOwner) {
            @if(checkAnexoPDF(anexo.id!)){
            <button type="button" matTooltip="Firmar anexo" mat-icon-button (click)="openDlgSignAnexo(anexo.id!)">
              <mat-icon>vpn_key</mat-icon>
            </button>
            }
            }
            }
          </div>
          <div matListItemTitle>
            @if (hasParticipated) {
            <a href="javascript:void(0)" matTooltip="{{getNombreAdjunto(anexo)}}"
              (click)="openAnexo(anexo.id!)">{{getNombreAdjunto(anexo)}}</a>
            }@else {
            <span matTooltip="{{anexo.nombre}}">{{getNombreAdjunto(anexo)}}</span>
            }
          </div>
          <div matListItemLine>
            {{anexo.nombre}}
            <br>            
            {{formatDate(anexo.fecha!)}}
          </div>
        </mat-list-item>
        }
      </mat-list>
    </fieldset>
    }
  </div>
</div>